 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		393: 0,
 		280: 0,
 		281: 0,
 		290: 0,
 		338: 0,
 		339: 0,
 		346: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","217":"AddClosedAlertIDUseCase","218":"CreateDeviceUseCase","219":"CreateDomestikaFollowUseCase","220":"CreateJWTUserUseCase","221":"CreateUserLiveSessionUseCase","222":"CurrentUserUseCase","223":"CurrentWithoutRelationshipsUserUseCase","224":"DeleteDeviceUseCase","225":"DeleteFollowUseCase","226":"ENV_CONFIG1","227":"ENV_CONFIG4","228":"ENV_CONFIG5","229":"ENV_CONFIG6","230":"ENV_CONFIG7","231":"FinishUserLiveSessionUseCase","232":"GetAccessTokenUserUseCase","233":"GetAdvanceGDPRStatusUserUseCase","234":"GetAllBlogUseCase","235":"GetAreasCourseUseCase","236":"GetCartCourseUseCase","237":"GetCategoriesCourseUseCase","238":"GetCourseUseCase","239":"GetFinalProjectVideoByCourseIDCourseUseCase","240":"GetGDPRStatusUserUseCase","241":"GetListLiveFeedbackQuestionUseCase","242":"GetListLiveSessionUseCase","243":"GetListLiveStreamUseCase","244":"GetLiveChannelUseCase","245":"GetLiveSessionUseCase","246":"GetOrganizationUseCase","247":"GetPlusPromotionUseCase","248":"GetPostContentBlogUseCase","249":"GetPromotionCodeAlertUseCase","250":"GetPromotionUseCase","251":"GetPubnubCredentialsUseCase","252":"GetSessionDataUserUseCase","253":"GetSimpleUserUseCase","254":"GetSoftwaresCourseUseCase","255":"GetUserAlertUseCase","256":"GetVideoProgressListCourseUseCase","257":"GetVideoSpeedUserUseCase","258":"GetVideoVolumeUserUseCase","259":"LogoutUserUseCase","260":"PathToRegexp","261":"RefreshAccessTokenUserUseCase","262":"RemoveAccessTokenUserUseCase","263":"SearchCourseUseCase","264":"SendHeaderTrackingUseCase","265":"SendLiveFeedbackAnswersUseCase","266":"SendPlayerTrackingUseCase","267":"SendTrackingUseCase","268":"SendVideoProgressCourseUseCase","269":"SetAdvanceGDPRStatusUserUseCase","270":"SetGDPRStatusUserUseCase","271":"SetVideoSpeedUserUseCase","272":"SetVideoVolumeUserUseCase","273":"UpdateLanguageUserUseCase","274":"UpdateLiveSessionUseCase","275":"UpdateVideoAudioAndSubtitlesCourseUseCase","276":"UpdateVideoProgressCourseUseCase","277":"ViewPageTrackingUseCase","347":"vendors~AddClosedAlertIDUseCase","348":"vendors~AmplitudeJS","349":"vendors~SearchCourseUseCase","350":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"615cf5f28390dc204056","1":"2874e71446ffa23bcb64","2":"00f2e5753f1e64932c31","3":"caba936f327a18c31e1c","4":"67b85c4a320e704a2030","5":"37943008c71fb292d87c","6":"c626ebb4127730a87a09","216":"7e94d8223f53f6d46a70","217":"858f69162da78627a6ca","218":"a4772bb7dea57b472864","219":"92f2098ca44aefdbb861","220":"23c2a04a4c326c3c90ab","221":"8f8befb044e37157d255","222":"c542e751937390e10236","223":"bbc9b59b89515f7b6fae","224":"cb16ea4de300c33aac58","225":"3a5fb9a4b4193272e92c","226":"f1c43e61a9cd6af4b62a","227":"7c5637ffa7ad5e2d4a61","228":"414384cfa4cf5a7a449a","229":"6b8c2e96facae9eda6fe","230":"beda36b5457f95a3cbbd","231":"e73e06926ba770ed44a8","232":"884492864e00b2c27837","233":"9baf012e6931aa652eee","234":"5a80ec5840461345d896","235":"773779b4a9950e015ab1","236":"26bf775eec94b844f895","237":"78a75709ed450b4f8c56","238":"4eafccb288b4e9d7898b","239":"45cd25c98063d9d82b08","240":"16181f6db734d8c696f7","241":"a4cb315849dd99bed430","242":"de09d2e9b5b39fcb42b9","243":"7bc5510d532c9f9d7d14","244":"2d562249aa990f2d790b","245":"30a719854c4100e7bce1","246":"18e5ed54f9b668cfc642","247":"5f3d9f85abffd1b72977","248":"15f5d589c9a262c3ed38","249":"7c355c359f28d8e909fd","250":"23348482d73aeb807885","251":"63a218bb94b9dfba6b8b","252":"36243cb805aba13b1af3","253":"15288facc4b21a0cf14b","254":"80a1237eaa030b02d961","255":"f1e38e33db086a6a9e63","256":"8dff355272b424713fd8","257":"0a9d975553f7dc316d83","258":"07f65da0ec3d0c8cddcf","259":"21135315a67894deb134","260":"322a34b8485ed4b0a791","261":"215ef5ed186e39333331","262":"eb0c620752eb299468f3","263":"b4d5186c92e473b8ad86","264":"dd3ccad1ee8b1cbe63d0","265":"43a603d8d6cea15932b6","266":"11060b1c72a88eab88fa","267":"aceb95821751b6451ce6","268":"a3bd0eaa8208598d4e34","269":"a2807b012a7a413c7cf5","270":"0db45a6032590d049357","271":"6a6e57bf8d7957131bd1","272":"f104734966e6887d71a8","273":"8aeeaa190afa341bf2d8","274":"848dd5c76bd46c5369f0","275":"1d659121dd631d230932","276":"bf2bac153b56a0cef2e5","277":"b4bf98f92f451b8b4900","347":"82e3f98d330228f74ff5","348":"154823aef86530281d52","349":"93c2d3d2ca34df88b10e","350":"db3d91264f4542d4f7b3","419":"999e93dc8bc6b55f628e","421":"85fa46afd25a98d72477","422":"fac4d23436d705151a74","640":"cde6e6d44f49b5cbcb28","641":"8bbfb5e0e7e6caf8ffeb","642":"d9d385dc1d69aa1b3324"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2187);
